<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-layout justify-center wrap>
            <v-flex md12>
                <material-card
                    color="green"
                    :title="getTitle()"
                    class="grid-card"
                    v-bind:class="{ 'hide-header': hideHeader }"
                >
                    <vue-good-table
                        ref="table"
                        :columns="columns"
                        :rows="rows"
                        :resource="title"
                        :url="url"
                        mode="remote"
                        v-on="
                            navigationPath
                                ? {
                                      'on-row-click': onRowClick,
                                  }
                                : {}
                        "
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-column-filter="onColumnFilter"
                        @on-filter-setup="setupFilter"
                        @on-per-page-change="onPerPageChange"
                        :totalRows="pagination.totalCount"
                        :headerMessage="headerMessage"
                        styleClass="vgt-table striped"
                        v-bind:selectOptions="
                            selectionEnabled
                                ? {
                                      enabled: true,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      //selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'Clear',
                                  }
                                : {}
                        "
                        v-bind:expandedOptions="
                            expandedOptions
                                ? {
                                      enabled: expandedOptions.enabled,
                                      allowExpandingAll:
                                          expandedOptions.allowExpandingAll,
                                  }
                                : {}
                        "
                    >
                        <div
                            slot="table-actions"
                            style="display: flex; flex-flow: row;"
                            class="action_buttons"
                            v-if="!hideActions"
                        >
                            <div v-for="action in actions" :key="action.text">
                                <v-btn
                                    v-if="
                                        isButton(action) &&
                                            (!action.showOnSelection ||
                                                getSelectedRows().length)
                                    "
                                    v-on:click="
                                        action.action
                                            ? runAction(action)
                                            : navigate(action)
                                    "
                                    :loading="
                                        actionsProcessing.includes(action.name)
                                    "
                                    :disabled="
                                        actionsProcessing.includes(action.name)
                                    "
                                    class="mx-2"
                                    small
                                    color="success"
                                >
                                    {{ action.text }}
                                    <template slot="loader">
                                        <span>
                                            <v-layout
                                                row
                                                class="pl-2 pr-3 my-1"
                                            >
                                                <v-icon
                                                    class="custom-loader pr-2"
                                                    light
                                                    >mdi-cached</v-icon
                                                >
                                                <div class="mt-1">
                                                    {{ action.text }}
                                                </div>
                                            </v-layout>
                                        </span>
                                    </template>
                                </v-btn>

                                <v-select
                                    style="width: 150px;"
                                    v-if="isDropdown(action)"
                                    :items="action.values"
                                    v-model="action.value"
                                    @change="action.onSelected"
                                    :label="action.text"
                                ></v-select>
                            </div>

                            <v-spacer></v-spacer>
                            <v-btn
                                v-if="!isUsingDefaultFilters()"
                                @click="resetFilters"
                                dark
                                class="mx-2"
                                small
                                color="default"
                            >
                                Reset Filter
                            </v-btn>
                            <v-spacer></v-spacer>
                            <download-excel
                                :fields="exportFields()"
                                :name="getExportFileName()"
                                :before-generate="() => (isExporting = true)"
                                :before-finish="() => (isExporting = false)"
                                :fetch="exportToExcel"
                                type="xls"
                            >
                                <v-btn small icon :loading="isExporting"
                                    ><v-icon color="success"
                                        >mdi-file-export</v-icon
                                    ></v-btn
                                >
                            </download-excel>
                            <v-menu :close-on-content-click="false" offset-y>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon small v-on="on"
                                        ><v-icon color="success"
                                            >mdi-format-list-bulleted</v-icon
                                        ></v-btn
                                    >
                                </template>
                                <v-card>
                                    <v-list class="column_list">
                                        <v-list-tile
                                            style="height: 30px;"
                                            v-for="column in columns.filter(
                                                (c) => !c.isIcon
                                            )"
                                            :key="column.label"
                                            @click="toggleColumn(column.field)"
                                        >
                                            <v-list-tile-action
                                                style="min-width: 35px;"
                                            >
                                                <v-icon v-if="column.hidden"
                                                    >mdi-close</v-icon
                                                >
                                                <v-icon v-if="!column.hidden"
                                                    >mdi-check</v-icon
                                                >
                                            </v-list-tile-action>
                                            <v-list-tile-title>{{
                                                column.label
                                            }}</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-card>
                            </v-menu>
                        </div>
                        <template
                            slot="table-column"
                            slot-scope="props"
                            class="text-xs-left"
                        >
                            <span
                                class="subheading font-weight-light text-success text--darken-3"
                            >
                                {{ props.column.label }}
                            </span>
                        </template>
                        <template slot="table-row" slot-scope="props">
                            <span
                                v-if="
                                    (props.column.link &&
                                        !props.column.showLink) ||
                                        (props.column.link &&
                                            props.column.showLink(props.row))
                                "
                            >
                                <router-link
                                    :to="{
                                        name: props.column.link,
                                        params: {
                                            id: props.row[props.column.field],
                                        },
                                    }"
                                    >{{
                                        props.row[props.column.field]
                                    }}</router-link
                                >
                            </span>
                            <span v-else-if="props.column.linkAction">
                                <a
                                    @click.stop="
                                        props.column.linkAction(props.row)
                                    "
                                    class=""
                                    >{{
                                        props.formattedRow[props.column.field]
                                    }}</a
                                >
                            </span>
                            <span v-else-if="props.column.isIcon" class="px-0">
                                <v-icon
                                    class="px-0"
                                    dark
                                    :color="
                                        props.column.iconColor(
                                            props.row[props.column.field]
                                        )
                                    "
                                    >{{
                                        props.column.icon(
                                            props.row[props.column.field]
                                        )
                                    }}</v-icon
                                >
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </template>
                        <template slot="expanded-row" slot-scope="props">
                            <component
                                v-if="expandedOptions"
                                :is="expandedOptions.template"
                                :row="props.row"
                                :columns="columns"
                                :reloadGrid="load"
                            />
                            <!-- <span v-html="getExpandedHtml(props)"></span> -->
                        </template>
                    </vue-good-table>
                    <v-flex class="py-0">
                        <v-layout row class="mt-3">
                            <v-flex xs3
                                ><div
                                    class="font-weight-regular"
                                    v-if="footerMessage"
                                >
                                    {{ footerMessage }}
                                </div>
                            </v-flex>
                            <v-flex xs6>
                                <v-layout justify-center>
                                    <v-pagination
                                        v-model="pagination.page"
                                        :length="pages"
                                        :total-visible="7"
                                        v-on:input="loadMore"
                                    ></v-pagination>
                                </v-layout>
                            </v-flex>
                            <v-flex xs3>
                                <v-layout row>
                                    <v-spacer></v-spacer>
                                    <v-flex xs8>
                                        <v-layout justify-end>
                                            <v-select
                                                v-if="!perPage"
                                                class="per-page"
                                                :items="
                                                    pagination.rowsPerPageOptions
                                                "
                                                label="Per Page"
                                                v-model="pagination.rowsPerPage"
                                            ></v-select>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </material-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import moment from "moment";
import { formatCurrency, getDomain } from "../../utils/helpers.js";
import odata from "odata-client";
// import store from "../store/modules";

export default {
    name: "data-grid",
    props: {
        url: { default: null, type: String },
        name: { type: String },
        baseUrl: { type: String },
        title: { type: String },
        footerMessage: { type: String },
        headerMessage: { type: String },
        mapper: { default: null, type: [Function, String] },
        navigationPath: { default: null, type: String },
        navigationField: { default: null, type: String },
        hideActions: { default: false, type: Boolean },
        hideHeader: { default: false, type: Boolean },
        selectionEnabled: { default: false, type: Boolean },
        columns: {},
        actions: {},
        sortOptions: {},
        expandedOptions: {},
        onRowClicked: { default: null, type: Function },
        beforeSetupGrid: { default: null, type: Function },
        onLoaded: { default: null, type: Function },
        perPage: { default: null, type: Number },
    },
    data: () => ({
        rows: [],
        pagination: {
            totalCount: 0,
            rowsPerPage: 12,
            page: 1,
            rowsPerPageOptions: [12, 25, 50, 100],
        },
        serverParams: {
            columnFilters: {},
            columnFilterTypes: {},
            sort: {
                field: "",
                type: "",
            },
            page: 1,
            perPage: 12,
        },
        isExporting: false,
        actionsProcessing: [],

        defaults: {
            sort: {
                field: "",
                type: "",
            },
        },
    }),
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(
                      this.pagination.totalCount / this.pagination.rowsPerPage
                  )
                : 0;
        },
    },
    watch: {
        "pagination.rowsPerPage": async function(newValue, oldValue) {
            this.serverParams.perPage = newValue;

            await this.load();

            this.onPerPageChange(newValue);
        },
    },
    async created() {
        if (this.beforeSetupGrid) {
            await this.beforeSetupGrid();
        }

        this.setupDefaults();

        await this.loadSavedSorting();

        this.setupBooleanColumns();

        await this.loadDropdownOptions();

        await this.load();

        await this.loadColumnConfigs();

        await this.loadSavedPageination();

        if (this.perPage) {
            this.pagination.rowsPerPage = this.perPage;
        }
    },
    methods: {
        getSelectedRowsData() {
            return [];
        },
        setupDefaults() {
            if (this.sortOptions && this.sortOptions.enabled) {
                this.defaults.sort = this.sortOptions.field;
                this.defaults.type = this.sortOptions.type;
            }
        },
        setupBooleanColumns() {
            if (this.columns.some((c) => c.type == "boolean")) {
                this.columns
                    .filter((c) => c.type == "boolean")
                    .forEach((column) => {
                        if (
                            !column.filterOptions.filterDropdownItems ||
                            !column.filterOptions.filterDropdownItems.length
                        ) {
                            column.filterOptions.filterDropdownItems = [
                                { value: true, text: "Yes" },
                                { value: false, text: "No" },
                            ];
                        }

                        if (!column.formatFn) {
                            column.formatFn = (value) => (value ? "Yes" : "No");
                        }
                    });
            }
        },
        async loadColumnConfigs() {
            //if (!this.$store.state.authentication.user) return;

            const name = this.name ? this.name : this.url.split("?")[0];

            //const user = this.$store.state.authentication.user;
            const user = "joel";

            const configs = await this.$http.get(
                `api/user/getConfig?userName=${user}&table=${name}`
            );

            const perPage = configs.find((c) => c.perPageCount);

            if (perPage) {
                this.serverParams.perPage = perPage.perPageCount;
                this.pagination.rowsPerPage = perPage.perPageCount;
            }

            this.columns
                .filter((c) => !c.isIcon)
                .forEach((column) => {
                    const config = configs.find((c) => c.field == column.field);

                    if (!config) return;

                    column.hidden = config.hidden;
                });
        },
        async loadSavedSorting() {
            const name = this.name ? this.name : this.url;

            const table = this.$store.state.app.dataTables.find(
                (t) => t.url == name
            );

            if (!table) {
                if (this.sortOptions && this.sortOptions.enabled) {
                    this.updateParams({
                        sort: {
                            field: this.sortOptions.field,
                            type: this.sortOptions.type,
                        },
                    });
                }

                return;
            }

            this.serverParams.sort = table.sort;
        },
        async loadSavedPageination() {
            const name = this.name ? this.name : this.url;

            const table = this.$store.state.app.dataTables.find(
                (t) => t.url == name
            );

            if (!table) return;

            if (table.page > 1) {
                this.serverParams.page = table.page;
                this.pagination.page = table.page;

                await this.loadMore();
            }
        },
        getUrl(url) {
            return url ? url : this.url;
        },
        buildRequest(url) {
            const baseUrl = this.baseUrl ? this.baseUrl : getDomain();

            const hasCustomParams = this.getUrl(url).includes("?");

            const setup = {
                service: baseUrl + "/odata/",
                resources: this.getUrl(url).split("?")[0],
            };

            if (hasCustomParams) {
                setup.custom = {};

                const urlParams = this.getUrl(url).split("?")[1];

                const params = urlParams.split("&");

                params.forEach((param) => {
                    const field = param.split("=")[0];
                    const value = param.split("=")[1];

                    setup.custom[field] = value;
                });
            }

            const request = odata(setup)
                .top(this.serverParams.perPage)
                .count(true);

            if (this.getFilter()) {
                request.filter(this.getFilter());
            }

            if (this.serverParams.sort.field && this.serverParams.sort.type) {
                request.orderby(
                    this.serverParams.sort.field,
                    this.serverParams.sort.type
                );
            }

            request._headers[
                "Authorization"
            ] = this.$store.state.authentication.token;

            return request;
        },

        handleResponse(response) {
            const reponseBody = JSON.parse(response.body);

            this.pagination.totalCount = reponseBody["@odata.count"];

            this.rows = this.mapResults(reponseBody.value);
        },

        async load(url = null) {
            const request = this.buildRequest(url);

            const response = await this.run(request);

            this.handleResponse(response);

            this.displayColumnSums();

            if (this.onLoaded) {
                this.onLoaded(this.rows);
            }
        },

        displayColumnSums() {
            if (!this.columns.some((c) => c.type == "decimal")) return;

            this.columns
                .filter((c) => c.type == "decimal" && c.showSum)
                .forEach(async (column) => {
                    const total = await this.loadColumnSum(column);

                    if (!column.label.includes("(")) {
                        return (column.label = column.label + ` ($${total})`);
                    }

                    column.label = column.label.split("(")[0] + ` ($${total})`;
                });
        },

        async loadColumnSum(column) {
            const filter = this.getFilter()
                ? `filter(${this.getFilter()})/`
                : "";

            const url = this.url.includes("?")
                ? this.url + "&"
                : this.url + "?";

            const response = await this.$http.get(
                `odata/${url}$apply=${filter}aggregate(${
                    column.field
                } with sum as Total)`
            );

            const value = response.value[0];

            if (!value) return 0;

            return value.Total || 0;
        },

        isButton(action) {
            return !action.type || action.type == "button";
        },
        isDropdown(action) {
            return action.type == "dropdown";
        },

        async loadDropdownOptions() {
            const dropdownColumns = this.columns.filter(
                (c) =>
                    c.isDropdown &&
                    c.filterOptions &&
                    c.filterOptions.filterDropdownItems
            );
            for (let index = 0; index < dropdownColumns.length; index++) {
                const column = dropdownColumns[index];
                // const filter = this.getFilter()
                //     ? `filter(${this.getFilter()})/`
                //     : "";
                const response = await this.$http.get(
                    `odata/${this.url}?$apply=groupby((${column.field}))`
                );

                const value = response.value;

                column.filterOptions.filterDropdownItems = !value
                    ? []
                    : value
                          .map((v) => v[column.field])
                          .filter(Boolean)
                          .sort();
            }
        },

        async loadAll() {
            const request = this.buildRequest();

            request.skip(0);
            request.top(this.pagination.totalCount);

            const response = await this.run(request);

            const reponseBody = JSON.parse(response.body);

            this.pagination.totalCount = reponseBody["@odata.count"];

            return this.mapResults(reponseBody.value);
        },

        async run(request) {
            this.$Progress.start();

            try {
                const response = await request.get();

                if (response.statusCode == 401) {
                    window.location.href = "/login";

                    return;
                }

                this.$Progress.finish();

                return response;
            } catch (e) {
                this.$notify({
                    group: "notification",
                    text: "An error has occurred",
                    type: "error",
                });

                this.$Progress.finish();
            }
        },

        async loadMore() {
            if (this.getSkip() >= this.pagination.totalCount) return;

            this.serverParams.page = this.pagination.page;

            this.savePagination();

            const request = this.buildRequest();

            request.skip(this.getSkip());

            const response = await this.run(request);

            return this.handleResponse(response);
        },

        getSkip() {
            const page = this.pagination.page - 1;

            let skip = page * this.pagination.rowsPerPage;

            if (skip >= this.pagination.totalCount) {
                skip = this.pagination.totalCount - this.pagination.rowsPerPage;
            }

            return skip;
        },

        savePagination() {
            this.$store.commit("app/setDataTable", {
                url: this.url,
                filters: this.serverParams.columnFilters,
                filterTypes: this.serverParams.columnFilterTypes,
                sort: this.serverParams.sort,
                page: this.serverParams.page,
            });
        },

        getExportFileName() {
            return this.title + " Export - " + moment().format("L");
        },

        exportFields() {
            let fields = {};

            this.columns.forEach((column) => {
                if (column.hidden) return;

                fields[column.label] = column.field;
            });

            return fields;
        },

        async exportToExcel() {
            const request = this.buildRequest();

            request.skip(0);
            request.top(this.pagination.totalCount);

            const response = await this.run(request);

            const reponseBody = JSON.parse(response.body);

            return reponseBody.value;
        },

        mapResults(results) {
            return this.mapper ? this.mapper(results) : results;
        },

        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);

            const table = this.$store.state.app.dataTables.find(
                (t) => t.url == this.url
            );

            if (!table) return;

            this.$store.commit("app/setDataTable", {
                url: this.url,
                filters: this.serverParams.columnFilters,
                filterTypes: this.serverParams.columnFilterTypes,
                sort: this.serverParams.sort,
                page: table ? table.page : 1,
            });
        },

        onRowClick(params) {
            if (this.onRowClicked) {
                this.onRowClicked(params.row);

                return;
            }

            this.$router.push({
                name: this.navigationPath,
                params: { id: params.row[this.navigationField] },
            });
        },

        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.load();
        },

        async onPerPageChange(perPage) {
            this.$refs.table.allExpended = false;

            if (!this.$store.state.authentication.user) return;

            //const url = this.baseUrl ? this.baseUrl : this.url;

            //const user = this.$store.state.authentication.user;
            const user = "joel";
            const name = this.name ? this.name : this.url.split("?")[0];

            await this.$http.post("api/user/save", {
                userName: user,
                dataTable: name,
                field: "PerPage",
                hidden: false,
                perPageCount: perPage,
            });
        },

        onSortChange(params) {
            this.pagination.page = 1;
            this.serverParams.page = 1;

            this.savePagination();

            this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
            this.load();
        },

        onColumnFilter(params) {
            this.pagination.page = 1;
            this.serverParams.page = 1;

            this.savePagination();

            this.updateParams(params);
            this.load();
        },

        setupFilter(params) {
            this.updateParams(params);
            this.load();
        },

        dateRangeFilter(propertyName, filterString) {
            function formatDate(date) {
                return new Date(date).toISOString();
            }

            let [field, term] = propertyName.split(".");

            const date = formatDate(Date.parse(filterString));

            if (term == "from") {
                return `(${field} ge ${date})`;
            }

            if (term == "to") {
                return `(${field} le ${date})`;
            }

            return filters;
        },
        decimalFilter(propertyName, value) {
            value = Number.parseFloat(value);

            let [field, extremum] = propertyName.split(".");

            if (extremum == "min") return `(${field} ge ${value})`;

            return `(${field} le ${value})`;
        },
        getFilter() {
            const filters = [].concat.apply(
                [],
                Object.entries(this.serverParams.columnFilters)
                    .map((filter) => {
                        const name = filter[0];
                        const value = filter[1];

                        if (["", undefined, null].includes(value)) return;

                        const { type, filterOptions } = this.columns.find(
                            (c) => c.field == name.split(".")[0]
                        );

                        if (type == "date") {
                            return this.dateRangeFilter(name, value);
                        }

                        if (type == "decimal") {
                            return this.decimalFilter(name, value);
                        }

                        if (type == "number" || type == "Number") {
                            return `${name} eq ${Number.parseFloat(value)}`;
                        }

                        if (type == "boolean") {
                            if (value == "true") {
                                return `${name} eq ${value}`;
                            }

                            return `(${name} eq ${value} or ${name} eq null)`;
                        }

                        if (
                            filterOptions &&
                            filterOptions.filterDropdownItems &&
                            filterOptions.filterDropdownItems.length
                        ) {
                            return Array.isArray(value)
                                ? `(${value
                                      .map((v) => `${name} eq '${v}'`)
                                      .join(" or ")})`
                                : `${name} eq '${value}'`;
                        }

                        const filterType = this.serverParams.columnFilterTypes[
                            name
                        ]
                            ? this.serverParams.columnFilterTypes[name]
                            : "";

                        if (filterType && filterType.startsWith("IS NOT")) {
                            return `not contains(${name}, '${value.trim()}')`;
                        }

                        return `contains(${name}, '${value.trim()}')`;
                    })
                    .filter(Boolean)
            );

            return `${filters.join(" and ")}`;
        },
        formatedDate(date) {
            return date ? moment(date).format("L") : "";
        },
        async toggleColumn(field) {
            const column = this.columns
                .filter((c) => !c.isIcon)
                .find((l) => l.field == field);

            column.hidden = !column.hidden;

            //if (!this.$store.state.authentication.user) return;

            const name = this.name ? this.name : this.url.split("?")[0];
            //const user = this.$store.state.authentication.user;
            const user = "joel";

            await this.$http.post("api/user/save", {
                userName: user,
                dataTable: name,
                field: field,
                hidden: column.hidden,
            });
        },
        getTitle() {
            return this.title + ` (${this.pagination.totalCount})`;
        },
        navigate(action) {
            this.$router.push({
                name: action.link,
                params: action.params,
            });
        },
        getSelectedRows() {
            if (!this.$refs.table) return [];

            return this.$refs.table.selectedRows;
        },
        async runAction(action) {
            if (action.name) {
                this.actionsProcessing.push(action.name);
            }

            try {
                await action.action(this.getSelectedRows());
            } catch (e) {
                if (action.name) {
                    const index = this.actionsProcessing.indexOf(action.name);

                    this.actionsProcessing.splice(index, 1);
                }
            }

            if (action.name) {
                const index = this.actionsProcessing.indexOf(action.name);

                this.actionsProcessing.splice(index, 1);
            }
        },
        getExpandedHtml(props) {
            if (!this.expandedOptions.getHtml) return "";

            return this.expandedOptions.getHtml(props);
        },
        resetFilters() {
            if (this.$refs.table) {
                this.$refs.table.restoreDefaults();
            }
        },
        isUsingDefaultFilters() {
            if (this.$refs.table) {
                return this.$refs.table.isUsingDefaultFilters();
            }
        },
    },
};
</script>
<style>
.column_list .v-list__tile {
    height: 30px !important;
}
.column_list .v-list__tile__action {
    min-width: 35px !important;
}

.action_buttons .v-btn.v-btn--icon {
    width: 41px;
    height: 30px !important;
    line-height: 30px !important;
}
.v-btn__content {
    color: unset;
}
.grid-card {
    margin-top: 35px !important;
}

.grid-card .v-card__text {
    padding-top: 10px;
}

.hide-header .v-card--material__header {
    display: none !important;
}

/*.v-btn__loading {
    position: relative;
}*/

.v-btn--loader.v-btn__content {
    display: none;
}

.custom-loader {
    animation: loader 1s infinite;
}
@-moz-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@-webkit-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@-o-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
